<template lang="pug">
VitePwaManifest
NuxtLayout
  NuxtPage
</template>

<script setup>
import { onMounted } from 'vue'

import { usePwaUpdate } from '@/composables/core/usePwaUpdate'

// App.vue - Nuxt 4 應用程式入口
// 這個檔案是 Nuxt 4 的標準入口點
// NuxtLayout 會自動載入 layouts/default.vue
// NuxtPage 會根據路由載入對應的頁面組件

// 移除初始 HTML loading 狀態
onMounted(() => {
  const loading = document.getElementById('app-loading')
  if (loading) {
    loading.remove()
  }
})

// 註冊 PWA 更新
const { registerPwaUpdate } = usePwaUpdate()
onMounted(() => {
  registerPwaUpdate()
})
</script>
